import { css } from "@emotion/react";

import { DesignToken, SpacingToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

export const noMarginStyles = css`
  margin: 0;
`;

export const tooltipIconStyles = css`
  padding-left: 2px;
  vertical-align: middle;
  display: inline-block;
  margin-bottom: -2px;
`;

export const tooltipContentStyles = css`
  font-family:
    Source Sans Pro,
    sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${withVar(DesignToken.ContentInvertPrimary)};
`;

export const footerButtonStyles = css`
  padding: 8px 16px;
`;

export const footerButtonGroupStyles = css`
  display: flex;
  gap: 8px;
`;

export const pickerBlockStyles = css`
  margin: 12px 0;
`;

export const pickerLabelStyles = css`
  font-weight: 600;
  margin-bottom: ${withVar(SpacingToken.Spacing3)};
`;

export const forwardingHeaderStyles = css`
  padding-bottom: 20px;
`;

export const modalBlockStyles = css`
  max-width: 600px;
`;

export const inputBlockStyles = css`
  margin: 0.5em 0 1em;
`;

export const inputLabelStyles = css`
  padding-top: 5px;
  width: 560px;
`;
